import 'slick-carousel/slick/slick.css';
import React from 'react';
import Slider from 'react-slick';
import styles from '../styles/TestimonialAnimation.module.scss';
import { MS_WATING_TESTIMONIALS } from 'constants/insurance';

interface ITestimonial {
  user: string;
  feedback: string;
}

const sliderSettings = {
  fade: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
};

const TestimonialCards = ({
  testimonial,
  isFirst,
}: {
  testimonial: ITestimonial;
  isFirst: boolean;
}) => {
  return (
    <div className={styles.container}>
      {isFirst ? (
        <div className={styles.promoText}>
          <span>{testimonial.user}</span>
          <div className={styles.text}>{testimonial.feedback}</div>
        </div>
      ) : (
        <div className={styles.feedback}>
          {`" ${testimonial.feedback} "`}
          <span>{testimonial.user}</span>
        </div>
      )}
    </div>
  );
};

const TestimonialAnimation = () => {
  return (
    <Slider {...sliderSettings}>
      {MS_WATING_TESTIMONIALS.map((t, index) => (
        <TestimonialCards
          key={`testimonial_${index}`}
          testimonial={t}
          isFirst={index === 0}
        />
      ))}
    </Slider>
  );
};

export default TestimonialAnimation;
